import { ISyncDownOptions } from "./options.interface";
import { ApiRequestOptions } from "../../../core/services/api/request-options";
const getDefaults = () => {
    return {
        query: undefined,
        since: undefined,
        quiet: false,
        priority: 0
    };
};

export interface ISyncDownOptionsEntityArgs {
    query?: object;
    since?: Date;
    quiet?: boolean;
    priority?: number;
    entity: string;
}

export class SyncDownOptionsEntity implements ISyncDownOptions {
    protected entity: string;
    protected priority?: number;
    protected query: object;
    protected since: Date;
    protected quiet: boolean;

    constructor(args?: ISyncDownOptionsEntityArgs) {
        args = {...getDefaults(), ...args};
        this.entity = args.entity;
        this.priority = args.priority;
        this.query = args.query;
        this.since = args.since;
        this.quiet = args.quiet;
    }

    getAuthenticated(): boolean {
        return true;
    }

    getEntity(): string {
        return this.entity;
    }

    getPriority(): number {
        return this.priority;
    }

    setPriority(priority: number): void {
        this.priority = priority;
    }

    getQuery(): object {
        return this.query;
    }

    setQuery(query: object): void {
        this.query = query;
    }

    getSince(): Date {
        return this.since;
    }

    setSince(since: Date): void {
        this.since = since;
    }

    getQuiet(): boolean {
        return this.quiet;
    }

    setQuiet(value: boolean): void {
        this.quiet = value;
    }

    getForce(): boolean {
        return false;
    }

    toApiRequestOptions(): ApiRequestOptions {
        return new ApiRequestOptions({
            authenticated: true,
            since: this.getSince(),
            query: this.getQuery()
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/services/sync-down/options-entity.ts